// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import StationQueue from './StationQueue'

/**
 * Intake queue — newly submitted Rxs awaiting first-pass verification.
 * Per PM-2 + U-04 (PharmacistInCharge): pharmacy ops calls this "intake"
 * not "verification" because the queue includes Rxs that are pre-verified
 * by an RPh and Rxs that haven't been seen yet. The verification *action*
 * happens here but the *queue* is operationally called intake.
 */
export default function IntakeTab() {
  return (
    <StationQueue
      states="submitted"
      tabKey="intake"
      title="Intake"
      subtitle="Newly submitted prescriptions awaiting verification."
      emptyMessage="No new prescriptions in intake."
    />
  )
}
